module.exports = __webpack_public_path__ + "img/Bookmark.bc3abd19.svg";